(function($) {
	
	$(document).ready(function() {
		
		$('#casestudy-document-search select').change(function() {
			// get selected filter parameters
			var category = $('#casestudy-document-search_category').val();
			var language = $('#casestudy-document-search_language').val();
			// build query string
			var querystring = '';
			// hide error message
			$('.no-documents').hide();
			// hide all and remove zebra class
			$('#casestudy-document-results tbody tr').hide().removeClass('even');
			// select according to filter
			if (category && language) {
				$('#casestudy-document-results tbody tr[data-category="' + category + '"][data-language="' + language + '"]').show();
				querystring = '?category=' + category + '&language=' + language;
			} else if (category) {
				$('#casestudy-document-results tbody tr[data-category="' + category + '"]').show();
				querystring = '?category=' + category;
			} else if (language) {
				$('#casestudy-document-results tbody tr[data-language="' + language + '"]').show();
				querystring = '?language=' + language;
			} else {
				$('#casestudy-document-results tbody tr').show();
			}
			// add even class to every second visible row (zebra effect)
			$('#casestudy-document-results tbody tr:visible:odd').addClass('even');
			// show error message
			if ($('#casestudy-document-results tbody tr:visible').length == 0) {
				$('.no-documents').show();
			}
			// update url
			var hash = '#downloads';
			if(history.pushState) {
				var href = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + window.location.pathname + querystring + hash;
			    history.pushState(null, null, href);
			} else {
			    window.location.hash = hash;
			    window.location.search = querystring;
			}
		});
		
		$('#casestudy-document-results tbody tr').click(function(e) {
			window.document.location = $(this).find('a').attr("href");
			return false;
		});
	});
	
}(jQuery));